import React from 'react';
import { usePrefs, useLabels } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';
import {
	inventoryCountsSelector,
	loadingInventoryCountsSelector
} from '../../server/selectors';
import { lookupInventoryCount } from '../../utils/inventoryKey';

const InventoryCount = ({ model = '', bodyStyle = '' }) => {
	const prefs = usePrefs();
	const labels = useLabels();
	const { inventoryCountLabel, showInventoryOnLotCount } = prefs;

	const showInventoryCount = showInventoryOnLotCount === 'true';

	const inventoryCounts = useSelector(inventoryCountsSelector);
	const loadingInventoryCounts = useSelector(loadingInventoryCountsSelector);

	// When the count is toggled off, render nothing at all rather than the
	// loading skeleton / empty spacer below — that ~15px placeholder otherwise
	// reserves space (and flashes on load) even though no count is shown.
	// Placed after the hooks above so the rules-of-hooks order is preserved.
	if (!showInventoryCount) {
		return null;
	}

	const inventoryCountItem = lookupInventoryCount(
		inventoryCounts,
		model,
		bodyStyle
	);

	// is 15 px as the font size is 10px (ddc-font-size-xsmall)
	// and the line height is 1.5
	const placeholderHeight = '15px';
	const placeholderWidth = '60px';

	if (loadingInventoryCounts.status) {
		return (
			<div
				data-testid="wsm-skeleton"
				className="d-flex justify-content-center m-0"
			>
				<Skeleton height={placeholderHeight} width={placeholderWidth} />
			</div>
		);
	} else if (
		loadingInventoryCounts.error ||
		Object.keys(inventoryCounts).length === 0
	) {
		return (
			<div
				data-testid="inventory-count-error"
				style={{
					height: placeholderHeight,
					width: placeholderWidth
				}}
			/>
		);
	}

	return (
		<span className="font-weight-extended-bold ddc-font-size-small text-center">
			<div className="touch-inventory-count ddc-font-size-xsmall font-weight-bold ">
				<span>{inventoryCountItem}</span>
				<span className={setClassNames(['inventory-count-label'])}>
					{` ${labels.get(inventoryCountLabel)}`}
				</span>
			</div>
		</span>
	);
};

InventoryCount.propTypes = {
	model: PropTypes.string.isRequired,
	bodyStyle: PropTypes.string
};

export default InventoryCount;
